// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Global-Elements/Footer-WF" transform="translate(-1169.000000, -197.000000)" fill="currentColor">
            <g transform="translate(1027.000000, 155.000000)">
                <g transform="translate(0.000000, 29.000000)">
                    <g transform="translate(130.000000, 0.000000)">
                        <path d="M27.94255,14.65045 C27.35255,14.93545 26.72555,15.11945 26.06105,15.20495 C26.73805,14.76895 27.25805,14.08245 27.50405,13.25995 C26.87055,13.66095 26.16955,13.94845 25.42255,14.11595 C24.82805,13.42845 23.97505,12.99995 23.03705,12.99995 C21.23055,12.99995 19.76605,14.57495 19.76605,16.52195 C19.76605,16.79545 19.79455,17.06595 19.84905,17.32045 C17.13555,17.18045 14.72205,15.77295 13.10805,13.64645 C12.82755,14.16495 12.66705,14.76895 12.66705,15.41645 C12.66705,16.63545 13.24355,17.71995 14.12255,18.34195 C13.58555,18.31995 13.08105,18.17045 12.64055,17.90395 L12.64055,17.95245 C12.64055,19.65495 13.76805,21.07645 15.26405,21.40495 C14.99005,21.48495 14.70055,21.52145 14.40005,21.52145 C14.19005,21.52145 13.99055,21.50695 13.78855,21.45895 C14.20305,22.86295 15.41205,23.88245 16.84305,23.90345 C15.72355,24.85245 14.31355,25.41045 12.78105,25.41045 C12.51605,25.41045 12.25505,25.39495 12.00005,25.36095 C13.44705,26.36495 15.16305,26.94945 17.01405,26.94945 C23.02955,26.94945 26.32105,21.58245 26.32105,16.92945 C26.32105,16.78095 26.31755,16.62995 26.31005,16.47895 C26.94855,15.97595 27.50405,15.35495 27.94255,14.65045"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Twitter);
